import React, { ReactNode } from 'react'

import { Tooltip } from 'antd'
import { TooltipPlacement } from 'antd/lib/tooltip'

interface TooltipProps {
  title: ReactNode
  position?: TooltipPlacement
  trigger?: any
  children: ReactNode
  style?: any
  overlay?: React.ReactNode
  overlayClassName?: string
  overlayInnerStyle?: React.CSSProperties
}

const Display = ({ children, ...restProps }: TooltipProps) => {
  return (
    <Tooltip title={restProps.title} placement={restProps.position} {...restProps}>
      {children}
    </Tooltip>
  )
}

export default Display
